import { getEventTracker } from '@libs/eventTracking'
import {
  getNextPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { paths } from '@routes/header-paths'

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-header/web-header.enter-creator-recruitment.md)
 */
export function trackHeaderEnterCreatorRecruitmentEvent() {
  getEventTracker().track({
    name: WebEventNames.WEB_HEADER_ENTER_CREATOR_RECRUITMENT,
    properties: {
      currentPage: getCurrentPagePropertyFor(''),
      toPage: getNextPagePropertyFor({
        pageName: 'creator-recruitment',
        pageUrl: window.location.origin + paths.poper,
      }),
    },
  })
}
